export default __webpack_public_path__ + "resources/icons/d432-b119.webp";